
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"text-indent":"0","text-transform":"none","block-progression":"tb"},attrs:{"d":"M17 20c-4.934 0-9 4.066-9 9v42c0 4.934 4.066 9 9 9h66c4.934 0 9-4.066 9-9V29c0-4.934-4.066-9-9-9H17zm.5 6h64.969L52.03 54.094c-1.426 1.316-2.702 1.315-4.125 0L17.5 26zM14 30.906L43.812 58.5c3.441 3.181 8.872 3.176 12.313 0L86 30.906V71c0 1.714-1.286 3-3 3H17c-1.714 0-3-1.286-3-3V30.906z","overflow":"visible","color":"#000"}})])
          )
        }
      }
    